// eslint-disable-next-line
import {injectable} from "inversify";

import {IShop, IUser} from "../../models/User";
import {IApiResponse, IHttpService} from "../http-service";


import {rootContainer, TYPE} from '../container/root';
import {FEATURES} from "../../models/Plan";
import { IOnboardingStep } from "../../pages/home/stores/onboarding-step-store";
import {
    MerchantPortalDto
} from "../../components/layouts/app-layout/app-header/merchant-portals-menu/merchant-portal-menu-list-store";

export interface IPortalService {
    getCurrentPortal: () => Promise<IUser>;
    activateRGOPortalForGlobaleStore: () => Promise<void>;
}

export interface IUserFeature {
    feature_id: FEATURES,
    is_allowed: boolean,
    quota: number
}

export interface IUserIdentity {
    portal_id: number;
    portal_name: string;
    logged_in_user_id: number;
    logged_in_user_email: string;
	logged_in_user_role: string;
	logged_in_user_company: string;
}

type RedirectTo = {
    redirectTo: string;
}

@injectable()
class PortalService implements IPortalService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async getCurrentPortal(): Promise<IUser> {
        const res = await this.httpService.get<IApiResponse<IUser>>(`/rms-api/user`);
        return res.payload;
    };

    public async activateRGOPortalForGlobaleStore(): Promise<void> {
        await this.httpService.post<IApiResponse<{ successful_activation: boolean }>>('/rms-api/user/activate-globale-store');
    }

    public async updateCurrentPortal(user: IUser): Promise<IUser> {
        const res = await this.httpService.put<IApiResponse<IUser>>(`/rms-api/user`, user);
        return res.payload;
    };

    public async searchShops(key: string, includeSecondaryPortals: boolean = false): Promise<IShop[]> {
        const res = await this.httpService.get<IApiResponse<IShop[]>>(`/rms-api/search-stores?key=${key}&include_secondary_portals=${includeSecondaryPortals}`);
        return res.payload;
    };

    public async assignPlanToShops(planId: number, storeIds: number[]): Promise<IShop[]> {
        const postData = {plan_id: planId, store_ids: storeIds};
        const res = await this.httpService.post<IApiResponse<IShop[]>>(`/rms-api/stores-assign-plan`, postData);
        return res.payload;
    };

    /** used to show/hide or style components according to users feature configurations */
    public async getUserFeatures(idList: FEATURES[]): Promise<IUserFeature[]> {
        const query = idList.join(',');
        const res = await this.httpService.get<IApiResponse<IUserFeature[]>>(`/rms-api/user/features?ids=${query}`);
        return res.payload;
    }

    public async getCurrentPortalOnboardingStatus(): Promise<IOnboardingStep[]> {
        const res = await this.httpService.get<IApiResponse<IOnboardingStep[]>>(`/rms-api/user/onboarding-status`);
        return res.payload;
    };

    public async getCurrentPortalIdentity(): Promise<IUserIdentity> {
        const res = await this.httpService.get<IApiResponse<IUserIdentity>>('/rms-api/user/identity');
        return res.payload;
    }

    public async getPortals(): Promise<MerchantPortalDto[]> {
        const res = await this.httpService.get<IApiResponse<MerchantPortalDto[]>>('/rms-api/user/portals');
        return res.payload;
    }

    public async changePortal(portalId: number|string, reason?: string): Promise<RedirectTo> {
        const res = await this.httpService.put<IApiResponse<RedirectTo>>('/rms-api/user/change-portal', { portal_id: portalId, reason });
        return res.payload;
    }
}


export default PortalService;
